import WithRender from "../../templates/imageEditor/walpaperLines.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getPOIEVariables", "getFormat"]),
    format: function () {
      return this.getFormat;
    },
    getLines: function () {
      var lines = this.getNumberOfLines() - 1;
      var result = lines > 0 ? lines : 0;
      this.$store.commit("changeSplit", result);
      return result;
    },
    show: function () {
      return this.getPOIEVariables.splitOiePdf;
    }
  },
  methods: {
    getNumberOfLines: function () {
      var format = this.format;
      if (format.width > 100) {
        var max = Math.floor(format.width / this.maxStep);
        var min = Math.ceil(format.width / this.minStep);
        return Math.floor((max + min) / 2);
      }
      return 0;
    },
    getLeft: function (total, n) {
      total = total + 1;
      return {
        left: (100 / total) * n + "%"
      };
    }
  }
});
